import React from "react";

const TeamSection = ({ hclass }) => {
    return (
        <section className={hclass}>
            {/* <div className="container">
                {showSectionTitle && (
                    <div className="row justify-content-center">
                        <div className="col-lg-9 col-12">
                            <SectionTitle title={'Our Team'} subtitle={'Meet Our Specialists'} />
                        </div>
                    </div>
                )}
                <div className="row">
                    {Teams.slice(sliceStart, sliceEnd).map((team, titem) => (
                        <div className="col-lg-4 col-md-6 col-12" key={titem}>
                            <div className="team_card">
                                <div className="image">
                                    <img src={team.timg} alt=""/>
                                        <div className="border-shape">
                                        <img src={borderShape} alt="" />
                                        </div>
                                </div>
                                <div className="content">
                                    <h3><Link onClick={ClickHandler} to={`/team-single/${team.slug}`}>{team.title}</Link></h3>
                                    <span>{team.subtitle}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div> */}
        </section>
    )
}
export default TeamSection;

